module.exports = __webpack_public_path__ + "static/img/health-fitness@3x.9676cd74.png";